import { TrackingConsent } from '@albelli/tracking-consent';
import { useContext, useEffect } from 'preact/hooks';
import { domainPrefix } from '../../config/domainPrefix';
import { vendors } from '../../config/vendor';
import TranslationContext from '../translations/translationContext';

// set dynamic head values. Will supplement the template.html's values
function Head({ vendor, trackingDataLayer }) {
    const translations = useContext(TranslationContext);

    useEffect(() => {
        const htmlTag = document.getElementsByTagName('html')[0];
        htmlTag.setAttribute('lang', vendors[vendor].locale);
    }, [vendor]);

    useEffect(() => {
        if (!Object.keys(translations).length) {
            return;
        }

        document.title = translations['home.seo.title'] ? translations['home.seo.title'] : 'home.seo.title';

        metaTagHelper(vendor, translations);
    }, [vendor, translations]);

    // Mobile device detection
    useEffect(() => {
        const htmlDoc = document.documentElement;
        const userAgent = window.navigator.userAgent;

        if (userAgent.indexOf('Android') >= 0 || userAgent.indexOf('android') >= 0) {
            htmlDoc.classList.add('os-android');
        } else if (
            userAgent.indexOf('iPhone') >= 0 ||
            userAgent.indexOf('iPad') >= 0 ||
            userAgent.indexOf('iPod') >= 0
        ) {
            htmlDoc.classList.add('os-ios');
        }
    }, []);

    useEffect(() => {
        window.TC_data = window.TC_data || {};
        window.TC_data = { ...trackingDataLayer, ...window.TC_data };
    }, [trackingDataLayer]);

    // Cookie consent script
    useEffect(() => {
        if (!vendor) {
            return;
        }

        // normalise the env to the company standard
        let env;
        switch (process.env.APP_ENV) {
            case 'dev':
            case 'tst':
                env = 'test';
                break;
            case 'prd':
                env = 'prod';
                break;
            default:
                env = process.env.APP_ENV;
        }

        const config = {
            application: 'storefront',
            vendor,
            environment: env,
        };
        // @ts-ignore
        window.trackingConsent = new TrackingConsent(config);
        window.trackingConsent.init();
    }, [vendor]);
}

function metaTagHelper(vendor, translations) {
    const metaTags = [
        {
            name: 'description',
            content: translations['home.seo.description'],
        },
        { property: 'og:type', content: 'website' },
        {
            property: 'og:title',
            content: translations['home.seo.title'],
        },
        {
            property: 'og:description',
            content: translations['home.seo.description'],
        },
        { property: 'og:locale', content: vendors[vendor].locale.replace('-', '_') },
        {
            property: 'og:url',
            content: `https://${domainPrefix}${vendor}/lp/`,
        },
        { property: 'og:site_name', content: vendor },
        {
            property: 'og:image',
            content: `https://${domainPrefix}${vendor}/content/default_${vendor}.jpg`,
        },
        {
            property: 'og:secure_url',
            content: `https://${domainPrefix}${vendor}/content/default_${vendor}.jpg`,
        },
        {
            property: 'og:twitter_image',
            content: `https://${domainPrefix}${vendor}/content/default_${vendor}.jpg`,
        },
        { property: 'og:site_name', content: vendor },
    ];

    const headElement = document.head || document.querySelector('head');

    metaTags.forEach((tag) => {
        if (tag.content) {
            const tagAttribute = tag.property ? 'property' : 'name';
            const tagIdentifier = tag.property || tag.name || '';

            let metaTag = headElement.querySelector(`meta[${tagAttribute}="${tagIdentifier}"]`);

            if (!metaTag) {
                metaTag = document.createElement('meta');
                metaTag.setAttribute(tagAttribute, tagIdentifier);

                headElement.appendChild(metaTag);
            }

            metaTag.setAttribute('content', tag.content);
        }
    });
}

export default Head;
